import { api } from "../../Config/ApiConfig";

export const resetPassword = async (newPassword, token) => {
    const { data } = await api.post('/auth/reset-password', { new_password: newPassword, token });
    return data;
};